import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MasonryService {

  constructor() { }

  /**
   * Set appropriate spanning to any masonry item
   *
   * Get different properties we already set for the masonry, calculate
   * height or spanning for any cell of the masonry grid based on its
   * content-wrapper's height, the (row) gap of the grid, and the size
   * of the implicit row tracks.
   */
  resizeMasonryItem(item: Element, gridClass: string, gap: number): void {
    /* Get the grid object, its row-gap, and the size of its implicit rows */
    const grid = document.getElementsByClassName(gridClass)[0],
      rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'), 10),
      rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'), 10);

    /*
     * Spanning for any brick = S
     * Grid's row-gap = G
     * Size of grid's implicitly create row-track = R
     * Height of item content = H
     * Net height of the item = H1 = H + G
     * Net height of the implicit row-track = T = G + R
     * S = H1 / T
     */
    const rowSpan = item && item.getBoundingClientRect() && Math.ceil((item.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap)) + gap;

    /* Set the spanning as calculated above (S) */
    item && item.setAttribute('style', `grid-row-end: span ${rowSpan}`);
  }

  /**
   * Apply spanning to all the masonry items
   *
   * Loop through all the items and apply the spanning to them using
   * `resizeMasonryItem()` function.
   *
   * @uses resizeMasonryItem
   */
  resizeAllMasonryItems(gridClass: string, ItemClass: string, rowGap: number = 1, loadImg: boolean = false): void {
    // Get all item class objects in one list
    const items = document.getElementsByClassName(ItemClass);

    /*
     * Loop through the above list and execute the spanning function to
     * each list-item (i.e. each masonry item)
     */
    for (let i = 0; i < items.length; i++) {
      if (loadImg) {
        items[i].querySelector('img').onload = () => {
          this.resizeMasonryItem(items[i], gridClass, rowGap);
        };
      }
      else {
        this.resizeMasonryItem(items[i], gridClass, rowGap);
      }
    }
  }
}
